import React from 'react';

import './AddMessage.scss';

class AddMessage extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        const { currentUser, addNewMessage} = this.props;
        const { requestId } = this.props.params;
        const { newMessageText } = this.refs;

        addNewMessage(requestId, currentUser, newMessageText.value);
        newMessageText.value = '';
        newMessageText.focus();
    }

    render() {
        const {params} = this.props;
        // const {bookInfo, requestInfo} = this.props.requests.find((r) => {
        //     return r.requestInfo.requestId === params.requestId;
        // });

        return (
            <div className="add-message">
                <form className="message-form" ref="commentForm" onSubmit={this.handleSubmit}>
                    <input type="text" ref="newMessageText" placeholder="Write New Message" />
                    <input type="submit" hidden />
                </form>
            </div>
        );
    }
}

export default AddMessage;



/** WEBPACK FOOTER **
 ** ./src/components/AddMessage/AddMessage.js
 **/